<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'nav-home',
  components: { },
  data() {
    return {
    }
  },
  methods: {
  }
};
</script>

<style lang='scss'>
.app-container{
  width: 100%;
  height: unset!important;
  overflow: auto;
}
</style>